<template>

    <div class="row">
        <div class="col-6">

            <sdg-chart
                title="National SDG"
                entity-class="App\Nation"
                :available-indicators="config.nation.sdg"
                :autoload="true"
                storage-item-name="welcomeChart1"
            ></sdg-chart>

            <sdg-chart
                title="District SDG"
                entity-class="App\District"
                :entities="config.district.entities"
                :available-indicators="config.district.sdg"
                :autoload="true"
                storage-item-name="welcomeChart2"
            ></sdg-chart>

            <sdg-chart
                title="Sector SDG"
                entity-class="App\Sector"
                :entities="config.sector.entities"
                :available-indicators="config.sector.sdg"
                :autoload="true"
                storage-item-name="welcomeChart5"
            ></sdg-chart>

        </div>

        <div class="col-6">

             <kpi-chart
                title="National KPI"
                entity-class="App\Nation"
                :available-indicators="config.nation.kpi"
                :autoload="true"
                storage-item-name="welcomeChart3"
            ></kpi-chart>

             <kpi-chart
                title="District KPI"
                entity-class="App\District"
                :entities="config.district.entities"
                :available-indicators="config.district.kpi"
                :autoload="true"
                storage-item-name="welcomeChart4"
            ></kpi-chart>

             <kpi-chart
                title="Sector KPI"
                entity-class="App\Sector"
                :entities="config.sector.entities"
                :available-indicators="config.sector.kpi"
                :autoload="true"
                storage-item-name="welcomeChart6"
            ></kpi-chart>

        </div>

    </div>

</template>

<script>

import KpiTimeChart from '../indicators/KpiTimeChart';
import SdgPieChart from '../indicators/SdgPieChart';

export default {

    components: {
        'kpi-chart': KpiTimeChart,
        'sdg-chart': SdgPieChart,
    },

    props: {

        // config should be in this format:
        // config.nation.sdg : array
        // config.nation.kpi : array
        // config.district.sdg : array
        // config.district.kpi : array
        // config.district.entities : array
        // etc...

        config: {
            type: Object,
            required: true,
        }
    },

    data() {

        return {
            APP_URL: window.APP_URL,
        };
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/WelcomeDashboard.vue